module.exports = "https://health.dajiuxing.com.cn/img/assets/img/turntable.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fturntable.png
// module id = 7wUH
// module chunks = 93